var $        = require("jquery");

var lib_core = require("lib-core");

/**
 * @constructor
 */
var DraggingStateMachine = function (root, model) {
    var self = this;

    this.root = root;
    this.model = model;

    lib_core.StateMachine.call(self);

    this.dragStartPoint = false;

    this.draggingStartTransition = self.addTransition("idle","mouse_down",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.UI_DRAG_MOUSE_DOWN;
        },
        function(cEvent){
            var mouseCoord = cEvent.data('mouseCoord');
            self.dragStartPoint = mouseCoord;

            self.model.uiSelectionModel(cEvent.element('uiSelectionModel'));
            // self.model.uiSelectionModel().setPos(mouseCoord.x, mouseCoord.y);
        }
    );

    this.draggingTransition = self.addTransition("mouse_down","mouse_down",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_MOVE;
        },
        function(cEvent){
            var mouseCoord = cEvent.data('mouseCoord');

            var dx = mouseCoord.x - self.dragStartPoint.x;
            var dy = mouseCoord.y - self.dragStartPoint.y;

            self.model.uiSelectionModel().move(dx,dy);

            self.dragStartPoint = mouseCoord;

        }
    );

    this.draggingEndTransition = self.addTransition("mouse_down","idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_UP;
        },
        function(cEvent){
            // var mouseCoord = cEvent.data('mouseCoord');
            // self.model.uiSelectionModel().setPos(mouseCoord.x, mouseCoord.y);
        }
    );
};
lib_core.inherit(DraggingStateMachine, lib_core.StateMachine);

module.exports = DraggingStateMachine;
